/**
 * Some helper functions useful to parse the category state
 **/

import TreeModel from 'tree-model';

const tree = new TreeModel();

/**
 * Tree traverse function to get a category by looking up the value of one of its properties
 * @param {ICategory[]} categories - category where we want to start the search
 * @param {string|number} propValue - value of the property we want to use to find a certain category
 * @param {string} propName - a specific category key, if it's undefined we will assume you want to use the id
 * @return {ICategory}
 */
export function findCategoryByProp(categories, propValue, propName = 'id') {
    const root = { type: 'root', children: categories };
    const node = tree.parse(root).first(n => !n.isRoot() && n.model[propName] === propValue);
    return node ? node.model : null;
}

/**
 * Get the main category slug
 * @param {ISlugParams} params
 * @returns {string}
 */
export function getMainCategorySlug(params) {
    let level2 = params.level2 ? `/${ params.level2 }` : '';
    return `${ params.level1 }${ level2 }`;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/categories/helpers.js